/**
 * «За всё время в ЮниКвесте» (ПР10 архива 1С, Р11): данные GET /api/grades/all-time и подписи блока.
 * Деньги = ставки (rate_paid) + такси; money_1c — часть, выплаченная через 1С (то же правило, что в зарплате:
 * дата раньше 01.03.2026 или назначение 1С) — подпись «выплачено через 1С» из @ub/shared/archive1c.
 */
import { PAID_1C_SHORT } from "@ub/shared/archive1c";

export interface AllTimeMoney { games: number; money: number; money_1c: number }
export interface AllTimeYear extends AllTimeMoney { year: string }
export interface AllTimeBranch extends AllTimeMoney { id: string; name: string; active: boolean }
export interface AllTimeQuest extends AllTimeMoney { id: string; name: string; active: boolean; branch_id: string; branch_name: string }
export interface AllTimeData {
  operator_id: string;
  cutoff: string;
  total: AllTimeMoney & { rate: number; taxi: number; unrated: number };
  first: { date: string; quest_id: string; quest_name: string; branch_id: string; branch_name: string } | null;
  years: AllTimeYear[];
  branches: AllTimeBranch[];
  quests: AllTimeQuest[];
}

/** Без operator_id — свои (кабинет оператора); с ним — выбранный оператор (вкладка ОО «Грейды»). */
export const allTimeUrl = (operatorId?: string): string =>
  operatorId ? `/api/grades/all-time?operator_id=${encodeURIComponent(operatorId)}` : "/api/grades/all-time";

/** «₽12 300» (неразрывный пробел между тысячами), минус — «−₽200». */
export function rub(n: number): string {
  const v = Math.round(Number(n) || 0);
  return `${v < 0 ? "−" : ""}₽${String(Math.abs(v)).replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
}

/** «игра», «игры», «игр» — слово к числу. */
export function gamesWord(n: number): string {
  const m10 = n % 10, m100 = n % 100;
  return m10 === 1 && m100 !== 11 ? "игра" : m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20) ? "игры" : "игр";
}

/** «1 игра», «3 игры», «12 игр». */
export const games = (n: number): string => `${n} ${gamesWord(n)}`;

/** Подпись денег: всё через 1С — «выплачено через 1С»; часть — «из них ₽N — выплачено через 1С»; иначе пусто. */
export function moneyNote(m: Pick<AllTimeMoney, "money" | "money_1c">): string {
  if (!m.money_1c) return "";
  if (m.money_1c === m.money) return PAID_1C_SHORT;
  return `из них ${rub(m.money_1c)} — ${PAID_1C_SHORT}`;
}

/** «2019-09-28» → «28.09.2019». */
export function dayRu(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso;
}

/** Строка «игры не вошли в сумму»: назначения без записанной ставки. */
export function unratedNote(n: number): string {
  return n > 0 ? `${games(n)} без записанной ставки — в сумму не вошли` : "";
}
